import { Quote } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const TestimonialsSection = () => {
  const { t } = useLanguage();

  const testimonials = [
    {
      nameKey: "testimonials.1.name",
      sectorKey: "testimonials.1.sector",
      quoteKey: "testimonials.1.quote",
    },
    {
      nameKey: "testimonials.2.name",
      sectorKey: "testimonials.2.sector",
      quoteKey: "testimonials.2.quote",
    },
    {
      nameKey: "testimonials.3.name",
      sectorKey: "testimonials.3.sector",
      quoteKey: "testimonials.3.quote",
    },
  ];

  return (
    <section className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            {t("testimonials.badge")}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t("testimonials.title")}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {t("testimonials.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="relative rounded-2xl border border-border/50 bg-card p-8 hover:border-primary/30 transition-all duration-300 hover:shadow-lg"
            >
              <Quote className="w-8 h-8 text-primary/20 mb-4" />
              <p className="text-foreground/90 text-base leading-relaxed mb-6">
                "{t(item.quoteKey)}"
              </p>
              <div className="border-t border-border/30 pt-4">
                <p className="font-semibold text-foreground">{t(item.nameKey)}</p>
                <p className="text-sm text-muted-foreground">{t(item.sectorKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
